"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               v5.29.3
// source: visibility.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.Visibility = exports.RestrictionReason = exports.VisibilityStatus = exports.protobufPackage = void 0;
exports.visibilityStatusFromJSON = visibilityStatusFromJSON;
exports.visibilityStatusToJSON = visibilityStatusToJSON;
exports.restrictionReasonFromJSON = restrictionReasonFromJSON;
exports.restrictionReasonToJSON = restrictionReasonToJSON;
/* eslint-disable */
const wire_1 = require("@bufbuild/protobuf/wire");
exports.protobufPackage = "visibility";
var VisibilityStatus;
(function (VisibilityStatus) {
    /** VISIBILITY_STATUS_UNSPECIFIED - The default value. */
    VisibilityStatus[VisibilityStatus["VISIBILITY_STATUS_UNSPECIFIED"] = 0] = "VISIBILITY_STATUS_UNSPECIFIED";
    /** VISIBILITY_STATUS_VISIBLE - The property is visible to the user without any restrictions. */
    VisibilityStatus[VisibilityStatus["VISIBILITY_STATUS_VISIBLE"] = 1] = "VISIBILITY_STATUS_VISIBLE";
    /** VISIBILITY_STATUS_HIDDEN - The property is hidden from the user. This is used when the property is not visible to the user due to a restriction. */
    VisibilityStatus[VisibilityStatus["VISIBILITY_STATUS_HIDDEN"] = 2] = "VISIBILITY_STATUS_HIDDEN";
    /** VISIBILITY_STATUS_PARTIALLY_VISIBLE - The property is partially visible to the user. This is used when the property is visible to the user, but only a subset of the data is visible. */
    VisibilityStatus[VisibilityStatus["VISIBILITY_STATUS_PARTIALLY_VISIBLE"] = 3] = "VISIBILITY_STATUS_PARTIALLY_VISIBLE";
    VisibilityStatus[VisibilityStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(VisibilityStatus || (exports.VisibilityStatus = VisibilityStatus = {}));
function visibilityStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "VISIBILITY_STATUS_UNSPECIFIED":
            return VisibilityStatus.VISIBILITY_STATUS_UNSPECIFIED;
        case 1:
        case "VISIBILITY_STATUS_VISIBLE":
            return VisibilityStatus.VISIBILITY_STATUS_VISIBLE;
        case 2:
        case "VISIBILITY_STATUS_HIDDEN":
            return VisibilityStatus.VISIBILITY_STATUS_HIDDEN;
        case 3:
        case "VISIBILITY_STATUS_PARTIALLY_VISIBLE":
            return VisibilityStatus.VISIBILITY_STATUS_PARTIALLY_VISIBLE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return VisibilityStatus.UNRECOGNIZED;
    }
}
function visibilityStatusToJSON(object) {
    switch (object) {
        case VisibilityStatus.VISIBILITY_STATUS_UNSPECIFIED:
            return "VISIBILITY_STATUS_UNSPECIFIED";
        case VisibilityStatus.VISIBILITY_STATUS_VISIBLE:
            return "VISIBILITY_STATUS_VISIBLE";
        case VisibilityStatus.VISIBILITY_STATUS_HIDDEN:
            return "VISIBILITY_STATUS_HIDDEN";
        case VisibilityStatus.VISIBILITY_STATUS_PARTIALLY_VISIBLE:
            return "VISIBILITY_STATUS_PARTIALLY_VISIBLE";
        case VisibilityStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var RestrictionReason;
(function (RestrictionReason) {
    /** RESTRICTION_REASON_UNSPECIFIED - The default value. */
    RestrictionReason[RestrictionReason["RESTRICTION_REASON_UNSPECIFIED"] = 0] = "RESTRICTION_REASON_UNSPECIFIED";
    /** RESTRICTION_REASON_BLOCKED_BY_PROVIDER - The property is blocked by the provider. This is used when the property is not visible to the user when accessed via the given tenant site due to licensing restrictions. */
    RestrictionReason[RestrictionReason["RESTRICTION_REASON_BLOCKED_BY_PROVIDER"] = 1] = "RESTRICTION_REASON_BLOCKED_BY_PROVIDER";
    /**
     * RESTRICTION_REASON_BLOCKED_BY_SELLER - The property is blocked by the seller. This is used when the property is not visible to the user because the seller has not allowed the listing to be displayed on Internet sites.
     *
     * For an detailed explanation of this restriction reason, see the RESO Data Dictionary
     * article: "[InternetEntireListingDisplayYN Field]."
     *
     * [InternetEntireListingDisplayYN Field]: https://ddwiki.reso.org/display/DDW17/InternetEntireListingDisplayYN+Field
     */
    RestrictionReason[RestrictionReason["RESTRICTION_REASON_BLOCKED_BY_SELLER"] = 2] = "RESTRICTION_REASON_BLOCKED_BY_SELLER";
    /**
     * RESTRICTION_REASON_PRIVATE_ADDRESS - The property is partially visible to the user but the address is private and not allowed to be displayed on Internet sites.
     *
     * For an detailed explanation of this restriction reason, see the RESO Data Dictionary
     * article: "[InternetAddressDisplayYN Field]."
     *
     * [InternetAddressDisplayYN Field]: https://ddwiki.reso.org/display/DDW17/InternetAddressDisplayYN+Field
     */
    RestrictionReason[RestrictionReason["RESTRICTION_REASON_PRIVATE_ADDRESS"] = 3] = "RESTRICTION_REASON_PRIVATE_ADDRESS";
    /**
     * RESTRICTION_REASON_PRIVATE_AUTOMATED_VALUATION - The property is partially visible to the user but Zoopraisal is private and not allowed to be displayed.
     *
     * For an detailed explanation of this restriction reason, see the RESO Data Dictionary
     * article: "[InternetAutomatedValuationDisplayYN Field]."
     *
     * [InternetAutomatedValuationDisplayYN Field]: https://ddwiki.reso.org/display/DDW17/InternetAutomatedValuationDisplayYN+Field
     */
    RestrictionReason[RestrictionReason["RESTRICTION_REASON_PRIVATE_AUTOMATED_VALUATION"] = 4] = "RESTRICTION_REASON_PRIVATE_AUTOMATED_VALUATION";
    RestrictionReason[RestrictionReason["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(RestrictionReason || (exports.RestrictionReason = RestrictionReason = {}));
function restrictionReasonFromJSON(object) {
    switch (object) {
        case 0:
        case "RESTRICTION_REASON_UNSPECIFIED":
            return RestrictionReason.RESTRICTION_REASON_UNSPECIFIED;
        case 1:
        case "RESTRICTION_REASON_BLOCKED_BY_PROVIDER":
            return RestrictionReason.RESTRICTION_REASON_BLOCKED_BY_PROVIDER;
        case 2:
        case "RESTRICTION_REASON_BLOCKED_BY_SELLER":
            return RestrictionReason.RESTRICTION_REASON_BLOCKED_BY_SELLER;
        case 3:
        case "RESTRICTION_REASON_PRIVATE_ADDRESS":
            return RestrictionReason.RESTRICTION_REASON_PRIVATE_ADDRESS;
        case 4:
        case "RESTRICTION_REASON_PRIVATE_AUTOMATED_VALUATION":
            return RestrictionReason.RESTRICTION_REASON_PRIVATE_AUTOMATED_VALUATION;
        case -1:
        case "UNRECOGNIZED":
        default:
            return RestrictionReason.UNRECOGNIZED;
    }
}
function restrictionReasonToJSON(object) {
    switch (object) {
        case RestrictionReason.RESTRICTION_REASON_UNSPECIFIED:
            return "RESTRICTION_REASON_UNSPECIFIED";
        case RestrictionReason.RESTRICTION_REASON_BLOCKED_BY_PROVIDER:
            return "RESTRICTION_REASON_BLOCKED_BY_PROVIDER";
        case RestrictionReason.RESTRICTION_REASON_BLOCKED_BY_SELLER:
            return "RESTRICTION_REASON_BLOCKED_BY_SELLER";
        case RestrictionReason.RESTRICTION_REASON_PRIVATE_ADDRESS:
            return "RESTRICTION_REASON_PRIVATE_ADDRESS";
        case RestrictionReason.RESTRICTION_REASON_PRIVATE_AUTOMATED_VALUATION:
            return "RESTRICTION_REASON_PRIVATE_AUTOMATED_VALUATION";
        case RestrictionReason.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseVisibility() {
    return {
        id: 0,
        mls: "",
        docId: "",
        listingKey: undefined,
        slug: undefined,
        visibilityStatus: 0,
        reason: undefined,
        tenantId: "",
    };
}
exports.Visibility = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.id !== 0) {
            writer.uint32(8).uint64(message.id);
        }
        if (message.mls !== "") {
            writer.uint32(18).string(message.mls);
        }
        if (message.docId !== "") {
            writer.uint32(26).string(message.docId);
        }
        if (message.listingKey !== undefined) {
            writer.uint32(34).string(message.listingKey);
        }
        if (message.slug !== undefined) {
            writer.uint32(42).string(message.slug);
        }
        if (message.visibilityStatus !== 0) {
            writer.uint32(48).int32(message.visibilityStatus);
        }
        if (message.reason !== undefined) {
            writer.uint32(56).int32(message.reason);
        }
        if (message.tenantId !== "") {
            writer.uint32(66).string(message.tenantId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVisibility();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.id = longToNumber(reader.uint64());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.mls = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.docId = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.listingKey = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.slug = reader.string();
                    continue;
                }
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.visibilityStatus = reader.int32();
                    continue;
                }
                case 7: {
                    if (tag !== 56) {
                        break;
                    }
                    message.reason = reader.int32();
                    continue;
                }
                case 8: {
                    if (tag !== 66) {
                        break;
                    }
                    message.tenantId = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.Number(object.id) : 0,
            mls: isSet(object.mls) ? globalThis.String(object.mls) : "",
            docId: isSet(object.docId) ? globalThis.String(object.docId) : "",
            listingKey: isSet(object.listingKey) ? globalThis.String(object.listingKey) : undefined,
            slug: isSet(object.slug) ? globalThis.String(object.slug) : undefined,
            visibilityStatus: isSet(object.visibilityStatus) ? visibilityStatusFromJSON(object.visibilityStatus) : 0,
            reason: isSet(object.reason) ? restrictionReasonFromJSON(object.reason) : undefined,
            tenantId: isSet(object.tenantId) ? globalThis.String(object.tenantId) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== 0) {
            obj.id = Math.round(message.id);
        }
        if (message.mls !== "") {
            obj.mls = message.mls;
        }
        if (message.docId !== "") {
            obj.docId = message.docId;
        }
        if (message.listingKey !== undefined) {
            obj.listingKey = message.listingKey;
        }
        if (message.slug !== undefined) {
            obj.slug = message.slug;
        }
        if (message.visibilityStatus !== 0) {
            obj.visibilityStatus = visibilityStatusToJSON(message.visibilityStatus);
        }
        if (message.reason !== undefined) {
            obj.reason = restrictionReasonToJSON(message.reason);
        }
        if (message.tenantId !== "") {
            obj.tenantId = message.tenantId;
        }
        return obj;
    },
    create(base) {
        return exports.Visibility.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const message = createBaseVisibility();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : 0;
        message.mls = (_b = object.mls) !== null && _b !== void 0 ? _b : "";
        message.docId = (_c = object.docId) !== null && _c !== void 0 ? _c : "";
        message.listingKey = (_d = object.listingKey) !== null && _d !== void 0 ? _d : undefined;
        message.slug = (_e = object.slug) !== null && _e !== void 0 ? _e : undefined;
        message.visibilityStatus = (_f = object.visibilityStatus) !== null && _f !== void 0 ? _f : 0;
        message.reason = (_g = object.reason) !== null && _g !== void 0 ? _g : undefined;
        message.tenantId = (_h = object.tenantId) !== null && _h !== void 0 ? _h : "";
        return message;
    },
};
function longToNumber(int64) {
    const num = globalThis.Number(int64.toString());
    if (num > globalThis.Number.MAX_SAFE_INTEGER) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    if (num < globalThis.Number.MIN_SAFE_INTEGER) {
        throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
    }
    return num;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=visibility.js.map